/** 临额申请场景值 */
export enum TempAmountSceneEnum {
  /** 点击"申请提额"-场景 */
  AMOUNT_BUTTON = 'amountButton',
  /** 电销 */
  CUSTOMER = 'customer',
  /** 提现金额、步长 不足提额条件(最低提现金额、步长) */
  AMOUNT_NOT_ENOUGH = 'amountNotEnough',
  /** "授信T3+未动支用户结合实时行为 */
  LOAN_CALC = 'loanCalc',
  /** 优质老客提现页主动提额 */
  PREMIUM_CUSTOMER_WITHDRAWAL = 'premiumCustomerWithdrawal',
}

/** 提额入口展示结果 */
export interface ShowLoanPageEntryResult {
  /** 是否展示提额入口 */
  showEntry: boolean;
}

/* 临额下发状态(通过tempAvailableAmount判断是否已下发成功) */
export interface TempAmountStatus {
  /** 临额可用金额，当下发成功后金额为非0 */
  tempAvailableAmount: number;
  /** 场景值 */
  scene: TempAmountSceneEnum;
  /** 临额下发状态: true 临额下发中,false 没有下发 */
  tempAmountApplying: boolean;
}

/* 临额下发申请结果 */
export interface ApplyTempAmountResult {
  /** 临额申请是否可以成功(true: 下发临额成功(此时临额还未到账), false: 下发失败) */
  tempAmountApplyResult?: boolean;
  /** 临额申请成功后，等待临额到账的超时时间(单位: 秒) */
  tempAmountArrivalTimeout?: number;
}

/** 事件通知-场景值 */
export enum EventLoopNotifySceneEnum {
  /** 临额 */
  TEMP_AMOUNT = 'tempAmount',
  /** 预授信 */
  PRE_CREDIT = 'preCredit',
}

/** 临额下发-业务数据 */
export interface NotifyTempAmountBusinessData {
  /** 临额可用金额，tempAvailableAmount > 0时，可更新临时额度 */
  tempAvailableAmount?: string;
  /** 临额场景：loanCalc,amountButton,customer,amountNotEnough */
  tempAmountApplyScene?: TempAmountSceneEnum;
  /** 临额下发状态: true 临额下发中,false 没有下发 */
  tempAmountApplying: boolean;
}

/** 预授信出额-业务数据 */
export interface NotifyPreCreditBusinessData {
  /** 预授信出额-是否需要刷新 */
  needRefresh?: boolean;
}

/* 临额下发申请结果 */
export interface EventLoopNotifyResult {
  /** 场景值 */
  scene: EventLoopNotifySceneEnum;
  /** 是否停止轮询 */
  stopLoop: true,
  /** 轮询超时时间 */
  timeOut: number,
  /** 场景自定义数据 */
  businessData: NotifyTempAmountBusinessData | NotifyPreCreditBusinessData;
}
